import { NavLink } from "react-router";
import { useAuthStore } from "../../stores/auth.store";
import { useUnreadCount } from "../../hooks/useMessages";

export function BottomNav() {
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);
  const unreadCount = useUnreadCount(!!user);

  const navItems = [
    { to: "/", label: "Home", icon: "H" },
    { to: "/explore", label: "Explore", icon: "E" },
    ...(user
      ? [{ to: "/messages", label: "Messages", icon: "M", badge: unreadCount }]
      : []),
    ...(user?.accountType === "business"
      ? [{ to: "/dashboard/bookings", label: "Dashboard", icon: "D" }]
      : []),
    ...(!isLoading
      ? [{ to: user ? "/account" : "/login", label: user ? "Account" : "Log in", icon: "A" }]
      : []),
  ];

  return (
    <nav aria-label="Mobile navigation" className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-white sm:hidden">
      <div className="flex items-center justify-around py-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            aria-label={item.label}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 text-xs focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-2 rounded ${
                isActive ? "text-gray-900 font-medium" : "text-gray-500"
              }`
            }
          >
            <span className="relative flex h-6 w-6 items-center justify-center rounded-full text-xs font-medium">
              {item.icon}
              {"badge" in item && (item as { badge?: number }).badge ? (
                <span className="absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-gray-900 px-1 text-[10px] font-semibold text-white">
                  {(item as { badge: number }).badge > 99
                    ? "99+"
                    : (item as { badge: number }).badge}
                </span>
              ) : null}
            </span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
